import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Icon from '@material-ui/core/Icon'
import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'

const styles = {
    list: {
      width: 200,
    }
};

const firebase = require('firebase')

const CustomDrawer = ({ classes, auth, toggleNavDrawer, toggleLoginDialog, isNavDrawerOpen, t }) => {
    const sideList = (
          <List>
            <Link to="/">
                <ListItem button>
                    <ListItemIcon>
                        <Icon><i className="fas fa-home" style={{verticalAlign: 'bottom'}}></i></Icon>
                    </ListItemIcon>
                    <ListItemText primary={t('home')} />
                </ListItem>
            </Link>
            {/* {!auth && (<ListItem button onClick={() => toggleLoginDialog(true)}>
                <ListItemIcon>
                    <Icon><i className="fas fa-sign-in-alt" style={{verticalAlign: 'bottom'}}></i></Icon>
                </ListItemIcon>
                <ListItemText primary="登入 / 註冊" />
            </ListItem>)}
            {auth && (<ListItem button onClick={() => firebase.auth().signOut()}>
                <ListItemIcon>
                <Icon><i className="fas fa-sign-out-alt" style={{verticalAlign: 'bottom'}}></i></Icon>
                </ListItemIcon>
                <ListItemText primary="登出" />
            </ListItem>)} */}
          </List>
    )

    return (
        <SwipeableDrawer open={isNavDrawerOpen} 
        onClose={() => toggleNavDrawer(false)}
        onOpen={() => toggleNavDrawer(true)}>
            <div className={classes.list} tabIndex={0}
            role="button"
            onClick={() => toggleNavDrawer(false)}
            onKeyDown={() => toggleNavDrawer(false)}>
                {sideList}
            </div>
        </SwipeableDrawer>
    )
}
  
CustomDrawer.propTypes = {
classes: PropTypes.object.isRequired,
};

export default translate('translations')(withStyles(styles)(CustomDrawer));


// WEBPACK FOOTER //
// ./src/components/CustomDrawer.js